// extracted by mini-css-extract-plugin
export default {"site-layout":"Sidenav_site-layout__hYUo3","site-layout-background":"Sidenav_site-layout-background__1uNVq","menuLabel":"Sidenav_menuLabel__kyIoJ"};